import React from "react";
import { GetDataForNavbarComponent } from "testly-web/queries";
import { NavBar } from "./NavBar";

export const NavbarContainer = () => (
  <GetDataForNavbarComponent>
    {({ data, ...other }) => data && <NavBar {...data.navbar} />}
  </GetDataForNavbarComponent>
);
